import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntregaObraClienteLoteUseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_lote_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportEntregaObraClienteLoteUseCase
 */

export class GetReportEntregaObraClienteLoteUseCase implements IGetReportEntregaObraClienteLoteUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    idsCliente?: number[],
    retrabalhos?: string[],
  ): Promise<void> {
    const response = await this.repository.getReportEntregaObraClienteLote(
      requiredMimeType,
      idEntregaObraCliente,
      idsCliente,
      retrabalhos
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `entrega_obra_cliente_lote${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }

  }
}
